import baseAPI from '@/api/base';
import {
  ChangeYurtzeitenEmailTemplateCategory,
  EditYurtzeitenEmailTemplate,
  GetYurtzeitenEmailTemplate,
  RegisterYurtzeitenEmailTemplate,
  ToggleYurtzeitenEmailTemplateIsActive,
  ToggleYurtzeitenEmailTemplateIsDefault,
} from '@/dtos/yurtzeiten_email_template.dto';
import {
  CHANGE_YURTZEITEN_EMAIL_TEMPLATE_CATEGORY_URL,
  DELETE_YURTZEITEN_EMAIL_TEMPLATE_URL,
  EDIT_YURTZEITEN_EMAIL_TEMPLATE_URL,
  GET_YURTZEITEN_EMAIL_TEMPLATE_URL,
  REGISTER_YURTZEITEN_EMAIL_TEMPLATE_URL,
  TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_ACTIVE_URL,
  TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_DEFAULT_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class YurtzeitenEmailTemplate {
  static getYurtzeitenEmailTemplates = async (
    getYurtzeitenEmailTemplate: GetYurtzeitenEmailTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      GET_YURTZEITEN_EMAIL_TEMPLATE_URL,
      {
        params: getYurtzeitenEmailTemplate,
      }
    );
    return response;
  };

  static registerYurtzeitenEmailTemplate = async (
    registerYurtzeitenEmailTemplate: RegisterYurtzeitenEmailTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_YURTZEITEN_EMAIL_TEMPLATE_URL,
      {
        ...registerYurtzeitenEmailTemplate,
      }
    );
    return response;
  };

  static editYurtzeitenEmailTemplate = async (
    editYurtzeitenEmailTemplate: EditYurtzeitenEmailTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_YURTZEITEN_EMAIL_TEMPLATE_URL,
      {
        ...editYurtzeitenEmailTemplate,
      }
    );
    return response;
  };

  static toggleYurtzeitenEmailTemplateIsActive = async (
    payload: ToggleYurtzeitenEmailTemplateIsActive
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_ACTIVE_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  // Sets the template as the organization's default, or clears it when it
  // already is. The server moves the flag off the previous default itself.
  static toggleYurtzeitenEmailTemplateIsDefault = async (
    payload: ToggleYurtzeitenEmailTemplateIsDefault
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_DEFAULT_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  // Moves the template to the other category. A default stays with the
  // category it was the default of, so the server clears it on the way out.
  static changeYurtzeitenEmailTemplateCategory = async (
    payload: ChangeYurtzeitenEmailTemplateCategory
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      CHANGE_YURTZEITEN_EMAIL_TEMPLATE_CATEGORY_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  static deleteYurtzeitenEmailTemplate = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_YURTZEITEN_EMAIL_TEMPLATE_URL}/${id}`
    );
    return response;
  };
}

export default YurtzeitenEmailTemplate;
